import React, { useEffect, useState } from "react";
import { MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import { toast } from "react-toastify";

import { useNavigate, useParams } from "react-router-dom";
// import { QRCodeSVG } from 'qrcode.react';
import AppWrapper from "../../../layout/AppWrapper";
import { th } from "../../../utils/helpers";
import { Button, Input, Label, Textarea } from "../../../styles";
import { ICON_EYE_FILL, ICON_MARK_STYLE, ICON_PEN, ICON_RECEIPT } from "../../../utils/icons";
import styled from "styled-components";
import BackButton from "../../BackButton";
import { useSalesContext } from "../../../context/sales_context";
import MiniLoader from "../../../utils/MIniLoader";
import { naira } from "../../../utils/data";
import { useWaybillContext } from "../../../context/waybill_context";
import AddWaybill from "../waybill/AddWaybill";
import Api from "../../../api/axios";
import { useUserContext } from "../../../context/user_context";

const InvoiceData = () => {

    const [issending, setissending] = useState(false);
    const [formField, setformField] = useState({
        customer_name: "",
        customer_mail: "",
        customer_phone: "",
    });

    const [editData, seteditData] = useState(true);
    const [showDes, setshowDes] = useState(false);
    const [showQr, setshowQr] = useState(false);
    const [markPaid, setMarkPaid] = useState(false);
    const [paymentLoading, setPaymentLoading] = useState(false);


    const params = useParams();
    const navigate = useNavigate();


    const { id: invid } = params;

    const {
        salesItemLoading, salesItem, getSalesItem,
    } = useSalesContext();
    const { btoken, stoken, usertoken } = useUserContext();


    const {
        openAddWaybill,
    } = useWaybillContext();

    const {
        sales_date,
        sales_items,
        customer_name,
        customer_mail,
        customer_phone,
        total_amount_th,
        details,
        userData,
        wayBill,
        status
    } = {} = salesItem;

    useEffect(() => {
        getSalesItem(invid);
    }, []);

    useEffect(() => {
        if (salesItem) {
            setformField({
                customer_name,
                customer_mail,
                customer_phone,
                details
            });
        }
    }, [salesItem]);


    function handleChange(e) {
        setformField((inputs) => ({
            ...inputs,
            [e.target.name]: e.target.value,
        }));
    }

    //  Update Business Details Function

    // function customerUpdate(e) {
    //     e.preventDefault();

    //     e.preventDefault();
    //     setissending(true);
    //     const data = {
    //         cname: cname,
    //         cphone: cphone,
    //         cmail: cmail,
    //         details: details,
    //         usertoken: token,
    //         btoken: btoken,
    //         invid: invid,
    //         stoken: stoken,
    //         apptoken: apptoken,
    //     };
    //     axios.post(`${ endpoint }/updateCustomerSalesRecord`,
    //         data)
    //         .then((res) => {
    //             if (res.data.success === false) {
    //                 setissending(false);
    //                 toast.warn(res.data.message);
    //             } else {
    //                 setissending(false);
    //                 toast.success(res.data.message);
    //                 seteditData(true);
    //             }
    //         })
    //         .catch((error) => {
    //             setissending(false);
    //             toast.error("Network Error!");
    //         });
    // }

    //  Update Business Details Function

    // Edit Function

    function onEdit() {
        seteditData(!editData);
        if (editData === true) {
            toast.success('You can now edit...');
        }
    }
    // Edit Function

    function paymentStatus() {
        if (status === 'Not Paid') {
            setMarkPaid(false);
        } else {
            setMarkPaid(true);
        }
    }

    function completePayment() {
        if (window.confirm(`Are you sure you want to confirm paid?`)) {
            setPaymentLoading(true);
            const data = {
                btoken, stoken, usertoken, invid
            };
            Api.post(`/invoice/mark.paid`, data)
                .then((res) => {
                    if (res.success === false) {
                        toast.warn(res.message);
                        setPaymentLoading(false);

                    } else {

                        setPaymentLoading(false);
                        toast.success(res.message);
                        getSalesItem(invid);
                    }
                })
                .catch((error) => {
                    setPaymentLoading(false);
                });
        }
    }

    // Check Access
    // Check Access
    const checkfeature = (feature) => {
        const data = JSON.parse(localStorage.getItem('features'))?.findIndex(x => x.feature === feature);

        if (data >= 0) {
            return true;
        } else {
            return false;
        }
    };

    // Check Access
    // Check Access



    function waybillAddOpen() {
        openAddWaybill();
    }
    function viewWaybill() {
        navigate(`/user/waybill/${ invid }`);
    }

    return (
        <StyledInvoiceData>
            <AppWrapper pagename={"sales"}>

                {/* Title */}
                <div className="dash-title mb-4">
                    <div className="d-flex align-items-center border-bottom">
                        <div className="d-flex col pry-bold-text align-items-center mb-2">
                            <h5 className='m-0'> SALES INVOICE
                            </h5>
                            <MiniLoader
                                load={salesItemLoading}
                            />
                        </div>
                        {!wayBill ?
                            <div className="mr-3 mb-2">
                                <Button
                                    pry
                                    type="submit"
                                    className="btn m-0"
                                    onClick={(e) => waybillAddOpen(e)}
                                >
                                    Add Waybill
                                </Button>
                            </div>
                            :
                            <div className="mr-3 mb-2">
                                <Button
                                    pry
                                    type="submit"
                                    className="btn m-0"
                                    onClick={(e) => viewWaybill(e)}
                                >
                                    {ICON_EYE_FILL} Waybill
                                </Button>
                            </div>
                        }
                    </div>

                </div>
                {/* Title */}
                <BackButton />

                {/* Customer Details */}
                {checkfeature('sales_edit') &&
                    <>
                        <div className="text-end">
                            <Button pry className="btn shadow-none"
                                onClick={onEdit}
                            >
                                {ICON_PEN} EDIT
                            </Button>
                        </div>
                    </>
                }
                <div className="row justify-content-center">
                    <div className="col-md-4 ">
                        <Label> Invoice Number: </Label>
                        <Input
                            value={invid}
                            disabled
                        />
                    </div>
                    <div className="col-md-4 col-6">
                        <Label> Date: </Label>
                        <Input
                            value={sales_date}
                            disabled
                        />
                    </div>
                    <div className="col-md-4 col-6">
                        <Label> Customer Phone: </Label>
                        <Input
                            name="customer_phone"
                            type="text"
                            onChange={handleChange}
                            value={formField?.customer_phone || 'Nil'}
                            disabled={editData}

                        />
                    </div>
                    <div className="col-md-6 ">
                        <Label> Customer Name: </Label>
                        <Input
                            name="customer_name"
                            type="text"
                            onChange={handleChange}
                            value={formField?.customer_name || 'Nil'}
                            disabled={editData}
                        />
                    </div>
                    <div className="col-md-6 ">
                        <Label> Customer Email: </Label>
                        <Input
                            name="customer_mail"
                            type="email"
                            onChange={handleChange}
                            value={formField?.customer_mail || 'Nil'}
                            disabled={editData ? true : false}
                        />
                    </div>
                    <div className="col-md-12 mb-4">
                        <div className="d-flex justify-content-between">

                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="des"
                                    onClick={(e) => setshowDes(!showDes)}
                                    checked={showDes}
                                />
                                <Label className="ml-2 m-0 small" for="des"> Description </Label>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="qr"
                                    onClick={(e) => setshowQr(!showQr)}
                                    checked={showQr}
                                />
                                <Label className="ml-2 m-0 small" for="qr"> Qr Code </Label>
                            </div>
                        </div>

                        {showDes &&
                            <>
                                <Textarea
                                    name="details"
                                    type="number"
                                    onChange={handleChange}
                                    value={formField?.details || 'Nil'}
                                    rows="3"
                                    placeholder="Description (optional) "
                                    disabled={editData}
                                ></Textarea>
                            </>
                        }
                    </div>

                    {!editData &&
                        <div className="col-md-12  mx-auto text-center">
                            <div className="mb-4">

                                <Button
                                    pry
                                    type="submit"
                                    className="btn w-lg-75 w-md-100"
                                    disabled={issending}
                                >
                                    {issending ? 'loading' : 'submit'}
                                </Button>
                            </div>
                        </div>
                    }
                    {showQr &&
                        <>
                            {/* <div className="mb-5">
                                <QRCodeSVG value={`https://reniaccounts.com/invoice/${ invid }`}
                                    bgColor="#f1f6fd"
                                    fgColor="#023676"
                                    level="H"
                                />
                            </div> */}
                        </>
                    }
                </div>
                {/* Customer Details */}



                {/* Item Details */}

                <MDBTable small responsive bordered>
                    <MDBTableHead color="pry" textWhite>
                        <tr>
                            <th className="text-center">No</th>
                            <th>Description</th>
                            <th className="text-center">Qty</th>
                            <th className="text-end pr-2">Price</th>
                            <th className="text-end pr-2">Amount</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody color="white" >
                        {sales_items?.map(({ item_name, qty, price, amount }, i) => (
                            <tr key={i}>
                                <td className="text-center">{i + 1}</td>
                                <td className="pt-3-half">
                                    {item_name}
                                </td>
                                <td className="text-center">
                                    {qty}
                                </td>
                                <td className="text-end pr-2">
                                    {naira}{th(price)}
                                </td>
                                <td className="text-end pr-2">
                                    {naira}{th(amount)}
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td className="text-center">=</td>
                            <td className="pt-3-half">
                                {/* VAT ({bData.vat_rate || 0.00}%) */}
                                VAT (0.00)%
                            </td>
                            <td className="text-center"></td>
                            <td className="text-end pr-2"></td>
                            <td className="text-end pr-2">
                                {/* ₦{vatData?.value || 0.00} */}
                                {naira + 0.00}
                            </td>
                        </tr>
                    </MDBTableBody>
                </MDBTable>

                {/* Item Details */}


                <h6 className="text-end mt-3 font-weight-light pry-bold-text border-bottom pb-2 "> TOTAL :
                    <span className="ms-5 mr-2 fw-bold">
                        {naira + (total_amount_th || 0.00)}
                        {/* {vatData ?
                            vatData === "inclusive" ?
                                cdata.total_amount_th :
                                th(Number(cdata.total_amount) + Number(vatData?.value))
                            : cdata.total_amount_th
                        } */}
                    </span>
                </h6>

                <div className=" border-bottom">
                    <h6 className="font-weight-bold pry-bold-text">
                        PAYMENT
                    </h6>
                    {(salesItemLoading || paymentLoading) ?
                        <MiniLoader
                            load={(salesItemLoading || paymentLoading)}
                        /> :
                        <>
                            {status === 'Paid' ?
                                <div className="green-bold-text text-center">
                                    This invoice has been marked PAID
                                    <h1 className="">
                                        {ICON_MARK_STYLE}
                                    </h1>
                                </div>
                                :
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        id="markPaid"
                                        onClick={(e) => completePayment()}
                                        checked={markPaid}
                                    />
                                    <Label className="ml-2 m-0 small" for="markPaid"> Mark as Paid </Label>
                                </div>

                            }
                        </>

                    }

                </div>
                <div className="my-3">
                    <small className="fit-content pry-text">
                        Attendant Name: {userData?.fullname || 'Nil'}
                    </small>
                </div>

                <div className="text-center mt-4 ">
                    <Button
                        pry
                        className="btn w-lg-75 w-md-100"
                        onClick={() => window.frames['frame1'].print()}
                    >
                        {ICON_RECEIPT} Print Receipt
                    </Button>

                    {/* <Link to={`/invoice/${ invid }`} target="_blank">
                        <button className="btn btn-pry p-0 py-1 px-2">
                            <i className="bi bi-link-45deg h4 p-0 m-0" />
                        </button>
                    </Link> */}
                </div>

                {/* Invoice Reciept */}
                <div className="mt-5">
                    <iframe src={`/user/invoice/${ invid }`} name="frame1" className="d-none w-100"></iframe>
                </div>
                {/* Invoice Reciept */}

            </AppWrapper>

            {/* Add Waybill Modal */}
            <AddWaybill
                invid={invid}
            />
            {/* Add Waybill Modal */}

        </StyledInvoiceData>
    );
};

export default InvoiceData;

const StyledInvoiceData = styled.section`
    
        input {
     height: 35px;
    }
`;
